import styled, { css } from 'styled-components';

const ProductFiltersStyled = styled.div.attrs({
  className: 'product-filters',
})`
  ${({ theme }) => {
    const { media } = theme;

    return css`
      .product-filters {
        &__sweetener {
          align-items: center;
          display: flex;
        }

        &__select {
          flex: 1 1 auto;
        }
      }
      ${media.tablet.up} {
        align-items: center;
        display: flex;

        .product-filters {
          &__sweetener {
            .label {
              font-weight: 800;
            }
            flex: 0 0 265px;
          }
        }
      }

      ${media.mobile.down} {
        .plan-packages__action-bar {
          display: flex;
          flex-direction: column;
          gap: 32px;
          align-items: center;
        }
        .product-filters {
          &__sweetener {
            margin: 0 auto;
            width: 265px;
          }
        }
      }
    `;
  }};
`;

export default ProductFiltersStyled;
